import React, { ReactNode }                         from "react";
import { connect }                                  from "react-redux";
import MenuType                                     from "../../../domain/menu/MenuType";
import { ResKaState }                               from "../../../index";
import BottomSection                                from "../../components/common/layout/BottomSection";
import RightPositionSection                         from "../../components/common/layout/RightPositionSection";
import TopSection                                   from "../../components/common/layout/TopSection";
import MailSendButton                               from "../../components/mail/MailSendButton";
import MailSendDestination                          from "../../components/mail/MailSendDestination";
import MailSendDestinationCustomerSelector          from "../../components/mail/MailSendDestinationCustomerSelector";
import MailSendDestinationGroupSelector             from "../../components/mail/MailSendDestinationGroupSelector";
import MailSendForm                                 from "../../components/mail/MailSendForm";
import MailSendTemplateSelector                     from "../../components/mail/MailSendTemplateSelector";
import OfficeSelector                               from "../../components/common/OfficeSelector";
import ResKaBaseContainer, { BaseProps, BaseState } from "../ResKaBaseContainer";

class MailSendContainer extends ResKaBaseContainer<BaseProps, BaseState> {
  constructor(props: BaseProps) {
    const state: BaseState = {
      headerTitle: "メール送信",
      menuType: MenuType.MAIL,
    };
    super(props, state);
  }

  protected componentDidMountInternal(): void {
  }

  protected renderInternal(): ReactNode {
    return (
      <>
        <RightPositionSection>
          <OfficeSelector/>
        </RightPositionSection>

        <TopSection>
          <MailSendDestinationCustomerSelector/>
          <MailSendDestinationGroupSelector/>
          <MailSendTemplateSelector/>
        </TopSection>

        <TopSection>
          <MailSendDestination/>
        </TopSection>

        <MailSendForm/>

        <BottomSection>
          <MailSendButton/>
        </BottomSection>
      </>
    );
  }
}

const mapStateToProps = (state: ResKaState) => ({
  fetchStatus: state.fetchStatus,
});

export default connect(mapStateToProps)(MailSendContainer);
